import { Mesh, MeshBasicMaterial, OrthographicCamera, PlaneGeometry, Scene, ShaderMaterial, type WebGLRenderer, WebGLRenderTarget } from "three"

export class TextureWriter {
  private readonly camera: OrthographicCamera
  private readonly scene: Scene
  // private readonly material: ShaderMaterial
  private readonly quad: Mesh
  private readonly renderer: WebGLRenderer

  constructor(renderer: WebGLRenderer) {
    this.renderer = renderer
    this.camera = new OrthographicCamera(-1, 1, 1, -1, 0, 1)
    this.scene = new Scene()
    // this.material = material
    this.quad = new Mesh(new PlaneGeometry(2, 2), new MeshBasicMaterial)
    this.scene.add(this.quad)
  }

  render(
    material: ShaderMaterial,
    target: WebGLRenderTarget,
  ): void {
    // console.log('TextureWriter.render')

    this.quad.material = material
    material.needsUpdate = true

    // 3. Render to the target (supports MRT via count parameter)
    this.renderer.setRenderTarget(target)
    this.renderer.render(this.scene, this.camera)
    this.renderer.setRenderTarget(null)

    // `target.texture` or `target.textures` (for MRT) is updated,
    // the caller shall enjoy the fruits of their labor
  }

  // Optional: Add a method to clean up resources
  dispose(): void {
    // console.log('TextureWriter.dispose')
    this.quad.geometry.dispose()
    const material = this.quad.material as MeshBasicMaterial
    material.dispose()
    this.scene.remove(this.quad)
  }
}
